import { render, staticRenderFns } from "./visit.vue?vue&type=template&id=42542cbd&scoped=true&"
import script from "./visit.vue?vue&type=script&lang=js&"
export * from "./visit.vue?vue&type=script&lang=js&"
import style0 from "./visit.vue?vue&type=style&index=0&id=42542cbd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42542cbd",
  null
  
)

export default component.exports